module.exports = __webpack_public_path__ + "img/CBvtt-new.ef6601cf.png";